import { ToastrService } from '../../../../../node_modules/ngx-toastr';
import { Component, OnInit, ViewContainerRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminRightsService } from 'src/app/Services/AdminRights/admin-rights.service';
import { ReminderEmail, GetReminderDataModel } from 'src/app/Models/AdminRights/reminder-email';


@Component({
  selector: 'app-reminder-email-config',
  templateUrl: './reminder-email-config.component.html',
  styleUrls: ['./reminder-email-config.component.css']
})
export class ReminderEmailConfigComponent implements OnInit {
  reminderEmail: ReminderEmail = new ReminderEmail();
  ReminderEmailForm: FormGroup;
  userId: string = localStorage.getItem('dsu_userId');
  reminderData: GetReminderDataModel[] = []


  constructor(private route: ActivatedRoute, private router: Router, private reminderEmailService: AdminRightsService, private form: FormBuilder, public vcr: ViewContainerRef, public toastr: ToastrService) {

  }

  ngOnInit() {
    this.ReminderEmailForm = this.form.group({
      AnnualReminderFirstDate: ['', Validators.required],
      AnnualReminderSecondDate: ['', Validators.required],
      ApprovalReminderFirstDate: ['', Validators.required],
      ApprovalReminderSecondDate: ['', Validators.required],
      CostReminderFirstDate: ['', Validators.required],
      CostReminderSecondDate: ['', Validators.required],
      MaterialReminderFirstDate: ['', Validators.required],
      MaterialReminderSecondDate: ['', Validators.required],
      DispatchReminderFirstDate: ['', Validators.required],
      DispatchReminderSecondDate: ['', Validators.required],
      DispatchToFTReminderFirstDate: ['', Validators.required],
      DispatchToFTReminderSecondDate: ['', Validators.required],

    });
    this.getReminderEmail(this.userId);
  }

  getReminderEmail(userId: any) {
    this.reminderEmailService.getReminderEmail(userId)
      .subscribe((resData: any) => {
        if (resData.status) {
          this.reminderData = resData.data;
          this.reminderData.forEach(element => {

            if (element.formId == '1') {
              this.ReminderEmailForm.patchValue({
                AnnualReminderFirstDate: element.reminder1Day,
                AnnualReminderSecondDate: element.reminder2Day
              });

            }
            else if (element.formId == '2') {
              this.ReminderEmailForm.patchValue({
                ApprovalReminderFirstDate: element.reminder1Day,
                ApprovalReminderSecondDate: element.reminder2Day
              });
            }
            else if (element.formId == '3') {
              this.ReminderEmailForm.patchValue({
                CostReminderFirstDate: element.reminder1Day,
                CostReminderSecondDate: element.reminder2Day
              });
            }
            else if (element.formId == '4') {
              this.ReminderEmailForm.patchValue({
                MaterialReminderFirstDate: element.reminder1Day,
                MaterialReminderSecondDate: element.reminder2Day
              });
            }
            else if (element.formId == '5') {
              this.ReminderEmailForm.patchValue({
                DispatchReminderFirstDate: element.reminder1Day,
                DispatchReminderSecondDate: element.reminder2Day
              });
            }
            else if (element.formId == '6') {
              this.ReminderEmailForm.patchValue({
                DispatchToFTReminderFirstDate: element.reminder1Day,
                DispatchToFTReminderSecondDate: element.reminder2Day
              });
            }

          });
        }
      });
  }

  reminderEmailConfigDetail(formData: any) {

    //const myForm=formData.values();
    // if (formData.value != null){
    //   // myForm.forEach(element => {
    //   //   if (element > 31) {
    //   //     this.toastr.error("Date cannot be greater than 31");
    //   //   }

    //   });
    //}

    if (formData.value.AnnualReminderFirstDate > 31 ||
      formData.value.AnnualReminderSecondDate > 31 ||
      formData.value.ApprovalReminderFirstDate > 31 ||
      formData.value.ApprovalReminderSecondDate > 31 ||
      formData.value.CostReminderFirstDate > 31 ||
      formData.value.CostReminderSecondDate > 31 ||
      formData.value.MaterialReminderFirstDate > 31 ||
      formData.value.MaterialReminderSecondDate > 31 ||
      formData.value.DispatchReminderFirstDate > 31 ||
      formData.value.DispatchReminderSecondDate > 31 ||
      formData.value.DispatchToFTReminderFirstDate > 31 ||
      formData.value.DispatchToFTReminderSecondDate > 31) {
      this.toastr.error("Date cannot be greater than 31");
    }



    else if (formData.value.AnnualReminderFirstDate < 1 || formData.value.AnnualReminderSecondDate < 0 ||
      formData.value.ApprovalReminderFirstDate < 1 || formData.value.ApprovalReminderSecondDate < 0 ||
      formData.value.CostReminderFirstDate < 1 || formData.value.CostReminderSecondDate < 0 ||
      formData.value.MaterialReminderFirstDate < 1 || formData.value.MaterialReminderSecondDate < 0 ||
      formData.value.DispatchReminderFirstDate < 1 || formData.value.DispatchReminderSecondDate < 0 ||
      formData.value.DispatchToFTReminderFirstDate < 1 || formData.value.DispatchToFTReminderSecondDate < 0) {
      this.toastr.error("Date cannot be less than 1");
      //this.resetReminderEmailConfig();
    }
    else if (formData.value.AnnualReminderFirstDate > formData.value.AnnualReminderSecondDate ||
      formData.value.ApprovalReminderFirstDate > formData.value.ApprovalReminderSecondDate ||
      formData.value.CostReminderFirstDate > formData.value.CostReminderSecondDate ||
      formData.value.MaterialReminderFirstDate > formData.value.MaterialReminderSecondDate ||
      formData.value.DispatchReminderFirstDate > formData.value.DispatchReminderSecondDate ||
      formData.value.DispatchToFTReminderFirstDate > formData.value.DispatchToFTReminderSecondDate) {
      this.toastr.error("First reminder date cannot be greater than second reminder date");
      //this.resetReminderEmailConfig();
    }
    else if (formData.value.AnnualReminderFirstDate == null || formData.value.AnnualReminderSecondDate == null ||
      formData.value.ApprovalReminderFirstDate == null || formData.value.ApprovalReminderSecondDate == null ||
      formData.value.CostReminderFirstDate == null || formData.value.CostReminderSecondDate == null ||
      formData.value.MaterialReminderFirstDate == null || formData.value.MaterialReminderSecondDate == null ||
      formData.value.DispatchReminderFirstDate == null || formData.value.DispatchReminderSecondDate == null ||
      formData.value.DispatchToFTReminderFirstDate == null || formData.value.DispatchToFTReminderSecondDate == null) {
      this.toastr.error("Date cannot be blank. Please enter a valid date.");
      //this.resetReminderEmailConfig();
    }
    else {
      this.reminderEmailService.postgetReminderEmail(formData)
        .subscribe((resData: any) => {
          if (resData.status) {
            this.toastr.success('Data Updated Successfully.');
          }
          else {
            this.toastr.error("Something Went Wrong.");
          }
        });
    }

  }
  onKeyPress(event: any) {
    if (event.key == "+" || event.key == "." || event.key == "-" || event.key == "e")
      return false;
    else
      return true;
  };
  resetReminderEmailConfig() {
    //     this.getReminderEmail();
  }

}
